import Vue from "vue";
import DataWebConfig from "@Scripts/Config/DataWebConfig";
import { router } from "@Scripts/Config/RouteConfig";
import { store } from "@Scripts/Config/StoreConfig";

export default class DataWebPage {
    public static async init() {
        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            Vue.use(DataWeb.default);
            Vue.use(DataWebConfig);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });

            let vm = new Vue({
                el: "#app",
                router,
                store,
                created() {
                    DataWeb.default.registerRoutes(router);
                    DataWeb.default.registerStoreModules(store);
                }
            });

            (<any>window).App.instances.vm = vm;
        }
    }
}